






















import Vue from "vue";

export default Vue.extend({
  name: "VContact",
  data() {
    return {
      contactVisible: false,
    };
  },
});
